import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export function useMe() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api.auth.me();
      } catch (err) {
        // Only a 401 means "not signed in" — resolve to null so the app routes
        // to /login. Anything else (network blip, 5xx) must throw: React Query
        // keeps the last known user on a failed refetch, whereas resolving to
        // null would unmount the whole authed tree. This query refetches on
        // window focus, so swallowing errors here meant one dropped request on
        // tab-return logged the UI out and back in — closing any open card
        // modal and discarding an in-progress comment.
        if ((err as { status?: number } | null)?.status === 401) return null;
        throw err;
      }
    },
    retry: false,
  });
  return { me: data ?? null, isLoading, isError };
}
